// extracted by mini-css-extract-plugin
export const photos = "memes-module--photos--3OImg";
export const caption = "memes-module--caption--2IxLs";